/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAcceptInvitationByToken } from '../../axios/organisationAcceptInvitationByToken'
import type {
	OrganisationAcceptInvitationByTokenError,
	OrganisationAcceptInvitationByTokenPathParams,
	OrganisationAcceptInvitationByTokenResponse,
} from '../../types/OrganisationAcceptInvitationByToken'

export const organisationAcceptInvitationByTokenMutationKey = () =>
	[{ url: '/organisations/invitations/accept-by-token/:token' }] as const

export type OrganisationAcceptInvitationByTokenMutationKey = ReturnType<
	typeof organisationAcceptInvitationByTokenMutationKey
>

export type OrganisationAcceptInvitationByTokenVariables = {
	token: OrganisationAcceptInvitationByTokenPathParams['token']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::acceptInvitationByToken */
export function useOrganisationAcceptInvitationByToken<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationAcceptInvitationByTokenResponse,
		AxiosError<OrganisationAcceptInvitationByTokenError>,
		OrganisationAcceptInvitationByTokenVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationAcceptInvitationByTokenMutationKey(),
		mutationFn: ({ token }: OrganisationAcceptInvitationByTokenVariables) =>
			organisationAcceptInvitationByToken(token, config).then(res => res.data),
		...options,
	})
}
